import { render, staticRenderFns } from "./shipping-tab-partial.vue?vue&type=template&id=39a5be89"
import script from "./shipping-tab-partial.vue?vue&type=script&lang=js"
export * from "./shipping-tab-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports